function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifier = function SvgMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 50,
    height: 48,
    viewBox: "-1 -1 54 54"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M51.73 43.78 41.36 33.41a22.15 22.15 0 0 0 3.04-11.22C44.4 9.96 34.44 0 22.2 0S0 9.96 0 22.2s9.96 22.2 22.2 22.2c3.96 0 7.82-1.05 11.22-3.04l10.37 10.37c.17.17.41.27.66.27s.49-.1.66-.28l6.61-6.61c.18-.17.28-.41.28-.66s-.1-.49-.27-.67M22.2 33.76c-6.37 0-11.56-5.19-11.56-11.56s5.19-11.56 11.56-11.56 11.56 5.19 11.56 11.56-5.19 11.56-11.56 11.56",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgMagnifier;